/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as OtpCodeRouteImport } from './routes/otp-code'
import { Route as AuthErrorRouteImport } from './routes/auth-error'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/_route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as Authenticated403RouteImport } from './routes/_authenticated/403'
import { Route as AuthenticatedKanzleiRouteRouteImport } from './routes/_authenticated/kanzlei/_route'
import { Route as AuthenticatedCompanyRouteRouteImport } from './routes/_authenticated/$company/_route'
import { Route as AuthenticatedCompanyIndexRouteImport } from './routes/_authenticated/$company/index'
import { Route as AuthenticatedKanzleiNutzerRouteImport } from './routes/_authenticated/kanzlei/nutzer'
import { Route as AuthenticatedAdminMandantErstellenRouteImport } from './routes/_authenticated/admin/mandant-erstellen'
import { Route as AuthenticatedAdminCompanySetupRouteImport } from './routes/_authenticated/admin/company-setup'
import { Route as AuthenticatedCompanyDoppelansichtRouteImport } from './routes/_authenticated/$company/doppelansicht'
import { Route as AuthenticatedCompanyUnternehmenRouteRouteImport } from './routes/_authenticated/$company/unternehmen/_route'
import { Route as AuthenticatedCompanyBuchhaltungRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/_route'
import { Route as AuthenticatedCompanyUnternehmenIndexRouteImport } from './routes/_authenticated/$company/unternehmen/index'
import { Route as AuthenticatedCompanyBuchhaltungIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/index'
import { Route as AuthenticatedCompanyUnternehmenUeberweisungenRouteImport } from './routes/_authenticated/$company/unternehmen/ueberweisungen'
import { Route as AuthenticatedCompanyUnternehmenBelegeRouteImport } from './routes/_authenticated/$company/unternehmen/belege'
import { Route as AuthenticatedCompanyUnternehmenAusgangsrechnungenRouteImport } from './routes/_authenticated/$company/unternehmen/ausgangsrechnungen'
import { Route as AuthenticatedCompanyBuchhaltungRechnungenRouteImport } from './routes/_authenticated/$company/buchhaltung/rechnungen'
import { Route as AuthenticatedCompanyBuchhaltungMandantBearbeitenRouteImport } from './routes/_authenticated/$company/buchhaltung/mandant-bearbeiten'
import { Route as AuthenticatedCompanyBuchhaltungLedgerRouteImport } from './routes/_authenticated/$company/buchhaltung/ledger'
import { Route as AuthenticatedCompanyUnternehmenTransaktionenRouteRouteImport } from './routes/_authenticated/$company/unternehmen/transaktionen/_route'
import { Route as AuthenticatedCompanyUnternehmenSettingsRouteRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/_route'
import { Route as AuthenticatedCompanyUnternehmenFullscreenRouteRouteImport } from './routes/_authenticated/$company/unternehmen/_fullscreen/_route'
import { Route as AuthenticatedCompanyUnternehmenFocusedRouteRouteImport } from './routes/_authenticated/$company/unternehmen/_focused/_route'
import { Route as AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/transaktionen/_route'
import { Route as AuthenticatedCompanyBuchhaltungEingangRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/_route'
import { Route as AuthenticatedCompanyBuchhaltungAusgangRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/_route'
import { Route as AuthenticatedCompanyBuchhaltungSettingsRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/_route'
import { Route as AuthenticatedCompanyBuchhaltungFocusedRouteRouteImport } from './routes/_authenticated/$company/buchhaltung/_focused/_route'
import { Route as AuthenticatedCompanyUnternehmenTransaktionenIndexRouteImport } from './routes/_authenticated/$company/unternehmen/transaktionen/index'
import { Route as AuthenticatedCompanyBuchhaltungTransaktionenIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/transaktionen/index'
import { Route as AuthenticatedCompanyBuchhaltungEingangIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/index'
import { Route as AuthenticatedCompanyBuchhaltungAusgangIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/index'
import { Route as AuthenticatedCompanyUnternehmenTransaktionenTodosRouteImport } from './routes/_authenticated/$company/unternehmen/transaktionen/todos'
import { Route as AuthenticatedCompanyBuchhaltungTransaktionenTodosRouteImport } from './routes/_authenticated/$company/buchhaltung/transaktionen/todos'
import { Route as AuthenticatedCompanyBuchhaltungTransaktionenExportRouteImport } from './routes/_authenticated/$company/buchhaltung/transaktionen/export'
import { Route as AuthenticatedCompanyBuchhaltungEingangUploadsRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/uploads'
import { Route as AuthenticatedCompanyBuchhaltungEingangStandardRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/standard'
import { Route as AuthenticatedCompanyBuchhaltungEingangSortRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/sort'
import { Route as AuthenticatedCompanyBuchhaltungEingangFastlaneRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/fastlane'
import { Route as AuthenticatedCompanyBuchhaltungEingangExportedRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/exported'
import { Route as AuthenticatedCompanyBuchhaltungEingangExportRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/export'
import { Route as AuthenticatedCompanyBuchhaltungEingangDuplicatesRouteImport } from './routes/_authenticated/$company/buchhaltung/eingang/duplicates'
import { Route as AuthenticatedCompanyBuchhaltungAusgangUploadsRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/uploads'
import { Route as AuthenticatedCompanyBuchhaltungAusgangStandardRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/standard'
import { Route as AuthenticatedCompanyBuchhaltungAusgangSortRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/sort'
import { Route as AuthenticatedCompanyBuchhaltungAusgangFastlaneRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/fastlane'
import { Route as AuthenticatedCompanyBuchhaltungAusgangExportedRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/exported'
import { Route as AuthenticatedCompanyBuchhaltungAusgangExportRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/export'
import { Route as AuthenticatedCompanyBuchhaltungAusgangDuplicatesRouteImport } from './routes/_authenticated/$company/buchhaltung/ausgang/duplicates'
import { Route as AuthenticatedCompanyUnternehmenReportingDashboardIndexRouteImport } from './routes/_authenticated/$company/unternehmen/reporting/dashboard/index'
import { Route as AuthenticatedCompanyUnternehmenReportingAccountsIndexRouteImport } from './routes/_authenticated/$company/unternehmen/reporting/accounts/index'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/index'
import { Route as AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRouteImport } from './routes/_authenticated/$company/unternehmen/_fullscreen/bezahlen/index'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/index'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/kreditoren'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren'
import { Route as AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRouteImport } from './routes/_authenticated/$company/unternehmen/_settings/einstellungen/bank'
import { Route as AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRouteImport } from './routes/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren'
import { Route as AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRouteImport } from './routes/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig'
import { Route as AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRouteImport } from './routes/_authenticated/$company/unternehmen/_fullscreen/bezahlen/error'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/weiterleitung'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/kostenstellen'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/konten'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten'
import { Route as AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRouteImport } from './routes/_authenticated/$company/buchhaltung/_settings/einstellungen/debitoren'
import { Route as AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRouteImport } from './routes/_authenticated/$company/buchhaltung/_focused/rechnung/seiten-bearbeiten'
import { Route as AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRouteImport } from './routes/_authenticated/$company/unternehmen/_focused/rechnung/$id/index'
import { Route as AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRouteImport } from './routes/_authenticated/$company/buchhaltung/_focused/rechnung/$id/index'
import { Route as AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRouteImport } from './routes/_authenticated/$company/unternehmen/_focused/rechnung/$id/seiten-bearbeiten'
import { Route as AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRouteImport } from './routes/_authenticated/$company/buchhaltung/_focused/rechnung/$id/seiten-bearbeiten'
import { Route as AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRouteImport } from './routes/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpCodeRoute = OtpCodeRouteImport.update({
  id: '/otp-code',
  path: '/otp-code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const Authenticated403Route = Authenticated403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKanzleiRouteRoute =
  AuthenticatedKanzleiRouteRouteImport.update({
    id: '/kanzlei',
    path: '/kanzlei',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyRouteRoute =
  AuthenticatedCompanyRouteRouteImport.update({
    id: '/$company',
    path: '/$company',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyIndexRoute =
  AuthenticatedCompanyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedKanzleiNutzerRoute =
  AuthenticatedKanzleiNutzerRouteImport.update({
    id: '/nutzer',
    path: '/nutzer',
    getParentRoute: () => AuthenticatedKanzleiRouteRoute,
  } as any)
const AuthenticatedAdminMandantErstellenRoute =
  AuthenticatedAdminMandantErstellenRouteImport.update({
    id: '/admin/mandant-erstellen',
    path: '/admin/mandant-erstellen',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminCompanySetupRoute =
  AuthenticatedAdminCompanySetupRouteImport.update({
    id: '/admin/company-setup',
    path: '/admin/company-setup',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyDoppelansichtRoute =
  AuthenticatedCompanyDoppelansichtRouteImport.update({
    id: '/doppelansicht',
    path: '/doppelansicht',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenRouteRoute =
  AuthenticatedCompanyUnternehmenRouteRouteImport.update({
    id: '/unternehmen',
    path: '/unternehmen',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungRouteRoute =
  AuthenticatedCompanyBuchhaltungRouteRouteImport.update({
    id: '/buchhaltung',
    path: '/buchhaltung',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenIndexRoute =
  AuthenticatedCompanyUnternehmenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungIndexRoute =
  AuthenticatedCompanyBuchhaltungIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenUeberweisungenRoute =
  AuthenticatedCompanyUnternehmenUeberweisungenRouteImport.update({
    id: '/ueberweisungen',
    path: '/ueberweisungen',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenBelegeRoute =
  AuthenticatedCompanyUnternehmenBelegeRouteImport.update({
    id: '/belege',
    path: '/belege',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute =
  AuthenticatedCompanyUnternehmenAusgangsrechnungenRouteImport.update({
    id: '/ausgangsrechnungen',
    path: '/ausgangsrechnungen',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungRechnungenRoute =
  AuthenticatedCompanyBuchhaltungRechnungenRouteImport.update({
    id: '/rechnungen',
    path: '/rechnungen',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute =
  AuthenticatedCompanyBuchhaltungMandantBearbeitenRouteImport.update({
    id: '/mandant-bearbeiten',
    path: '/mandant-bearbeiten',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungLedgerRoute =
  AuthenticatedCompanyBuchhaltungLedgerRouteImport.update({
    id: '/ledger',
    path: '/ledger',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenTransaktionenRouteRoute =
  AuthenticatedCompanyUnternehmenTransaktionenRouteRouteImport.update({
    id: '/transaktionen',
    path: '/transaktionen',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenSettingsRouteRoute =
  AuthenticatedCompanyUnternehmenSettingsRouteRouteImport.update({
    id: '/_settings',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFullscreenRouteRoute =
  AuthenticatedCompanyUnternehmenFullscreenRouteRouteImport.update({
    id: '/_fullscreen',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFocusedRouteRoute =
  AuthenticatedCompanyUnternehmenFocusedRouteRouteImport.update({
    id: '/_focused',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute =
  AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteImport.update({
    id: '/transaktionen',
    path: '/transaktionen',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangRouteRoute =
  AuthenticatedCompanyBuchhaltungEingangRouteRouteImport.update({
    id: '/eingang',
    path: '/eingang',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangRouteRoute =
  AuthenticatedCompanyBuchhaltungAusgangRouteRouteImport.update({
    id: '/ausgang',
    path: '/ausgang',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungSettingsRouteRoute =
  AuthenticatedCompanyBuchhaltungSettingsRouteRouteImport.update({
    id: '/_settings',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungFocusedRouteRoute =
  AuthenticatedCompanyBuchhaltungFocusedRouteRouteImport.update({
    id: '/_focused',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenTransaktionenIndexRoute =
  AuthenticatedCompanyUnternehmenTransaktionenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedCompanyUnternehmenTransaktionenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute =
  AuthenticatedCompanyBuchhaltungTransaktionenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangIndexRoute =
  AuthenticatedCompanyBuchhaltungEingangIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangIndexRoute =
  AuthenticatedCompanyBuchhaltungAusgangIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenTransaktionenTodosRoute =
  AuthenticatedCompanyUnternehmenTransaktionenTodosRouteImport.update({
    id: '/todos',
    path: '/todos',
    getParentRoute: () =>
      AuthenticatedCompanyUnternehmenTransaktionenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute =
  AuthenticatedCompanyBuchhaltungTransaktionenTodosRouteImport.update({
    id: '/todos',
    path: '/todos',
    getParentRoute: () =>
      AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungTransaktionenExportRoute =
  AuthenticatedCompanyBuchhaltungTransaktionenExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () =>
      AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangUploadsRoute =
  AuthenticatedCompanyBuchhaltungEingangUploadsRouteImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangStandardRoute =
  AuthenticatedCompanyBuchhaltungEingangStandardRouteImport.update({
    id: '/standard',
    path: '/standard',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangSortRoute =
  AuthenticatedCompanyBuchhaltungEingangSortRouteImport.update({
    id: '/sort',
    path: '/sort',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangFastlaneRoute =
  AuthenticatedCompanyBuchhaltungEingangFastlaneRouteImport.update({
    id: '/fastlane',
    path: '/fastlane',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangExportedRoute =
  AuthenticatedCompanyBuchhaltungEingangExportedRouteImport.update({
    id: '/exported',
    path: '/exported',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangExportRoute =
  AuthenticatedCompanyBuchhaltungEingangExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute =
  AuthenticatedCompanyBuchhaltungEingangDuplicatesRouteImport.update({
    id: '/duplicates',
    path: '/duplicates',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungEingangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangUploadsRoute =
  AuthenticatedCompanyBuchhaltungAusgangUploadsRouteImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangStandardRoute =
  AuthenticatedCompanyBuchhaltungAusgangStandardRouteImport.update({
    id: '/standard',
    path: '/standard',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangSortRoute =
  AuthenticatedCompanyBuchhaltungAusgangSortRouteImport.update({
    id: '/sort',
    path: '/sort',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute =
  AuthenticatedCompanyBuchhaltungAusgangFastlaneRouteImport.update({
    id: '/fastlane',
    path: '/fastlane',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangExportedRoute =
  AuthenticatedCompanyBuchhaltungAusgangExportedRouteImport.update({
    id: '/exported',
    path: '/exported',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangExportRoute =
  AuthenticatedCompanyBuchhaltungAusgangExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute =
  AuthenticatedCompanyBuchhaltungAusgangDuplicatesRouteImport.update({
    id: '/duplicates',
    path: '/duplicates',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungAusgangRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute =
  AuthenticatedCompanyUnternehmenReportingDashboardIndexRouteImport.update({
    id: '/reporting/dashboard/',
    path: '/reporting/dashboard/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute =
  AuthenticatedCompanyUnternehmenReportingAccountsIndexRouteImport.update({
    id: '/reporting/accounts/',
    path: '/reporting/accounts/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRouteImport.update({
    id: '/einstellungen/',
    path: '/einstellungen/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute =
  AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRouteImport.update({
    id: '/bezahlen/',
    path: '/bezahlen/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenFullscreenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRouteImport.update({
    id: '/einstellungen/',
    path: '/einstellungen/',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRouteImport.update(
    {
      id: '/einstellungen/whatsapp-weiterleitung',
      path: '/einstellungen/whatsapp-weiterleitung',
      getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRouteImport.update(
    {
      id: '/einstellungen/weiterleitung',
      path: '/einstellungen/weiterleitung',
      getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRouteImport.update(
    {
      id: '/einstellungen/kreditoren',
      path: '/einstellungen/kreditoren',
      getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRouteImport.update(
    {
      id: '/einstellungen/kostenstellen',
      path: '/einstellungen/kostenstellen',
      getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRouteImport.update(
    {
      id: '/einstellungen/debitoren',
      path: '/einstellungen/debitoren',
      getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute =
  AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRouteImport.update({
    id: '/einstellungen/bank',
    path: '/einstellungen/bank',
    getParentRoute: () => AuthenticatedCompanyUnternehmenSettingsRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute =
  AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRouteImport.update(
    {
      id: '/transaktionen/importieren',
      path: '/transaktionen/importieren',
      getParentRoute: () => AuthenticatedCompanyUnternehmenFullscreenRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute =
  AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRouteImport.update({
    id: '/bezahlen/fertig',
    path: '/bezahlen/fertig',
    getParentRoute: () => AuthenticatedCompanyUnternehmenFullscreenRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute =
  AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRouteImport.update({
    id: '/bezahlen/error',
    path: '/bezahlen/error',
    getParentRoute: () => AuthenticatedCompanyUnternehmenFullscreenRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRouteImport.update(
    {
      id: '/einstellungen/whatsapp-weiterleitung',
      path: '/einstellungen/whatsapp-weiterleitung',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRouteImport.update(
    {
      id: '/einstellungen/weiterleitung',
      path: '/einstellungen/weiterleitung',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRouteImport.update(
    {
      id: '/einstellungen/kreditoren',
      path: '/einstellungen/kreditoren',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRouteImport.update(
    {
      id: '/einstellungen/kostenstellen',
      path: '/einstellungen/kostenstellen',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRouteImport.update(
    {
      id: '/einstellungen/kontenplan',
      path: '/einstellungen/kontenplan',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRouteImport.update({
    id: '/einstellungen/konten',
    path: '/einstellungen/konten',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRouteImport.update(
    {
      id: '/einstellungen/konfiguration',
      path: '/einstellungen/konfiguration',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRouteImport.update(
    {
      id: '/einstellungen/kanzleiland',
      path: '/einstellungen/kanzleiland',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRouteImport.update(
    {
      id: '/einstellungen/integrationen',
      path: '/einstellungen/integrationen',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRouteImport.update(
    {
      id: '/einstellungen/exporte',
      path: '/einstellungen/exporte',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRouteImport.update(
    {
      id: '/einstellungen/eckdaten',
      path: '/einstellungen/eckdaten',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute =
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRouteImport.update(
    {
      id: '/einstellungen/debitoren',
      path: '/einstellungen/debitoren',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungSettingsRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute =
  AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRouteImport.update(
    {
      id: '/rechnung/seiten-bearbeiten',
      path: '/rechnung/seiten-bearbeiten',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungFocusedRouteRoute,
    } as any,
  )
const AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute =
  AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRouteImport.update({
    id: '/rechnung/$id/',
    path: '/rechnung/$id/',
    getParentRoute: () => AuthenticatedCompanyUnternehmenFocusedRouteRoute,
  } as any)
const AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute =
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRouteImport.update({
    id: '/rechnung/$id/',
    path: '/rechnung/$id/',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungFocusedRouteRoute,
  } as any)
const AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute =
  AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRouteImport.update(
    {
      id: '/rechnung/$id/seiten-bearbeiten',
      path: '/rechnung/$id/seiten-bearbeiten',
      getParentRoute: () => AuthenticatedCompanyUnternehmenFocusedRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute =
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRouteImport.update(
    {
      id: '/rechnung/$id/seiten-bearbeiten',
      path: '/rechnung/$id/seiten-bearbeiten',
      getParentRoute: () => AuthenticatedCompanyBuchhaltungFocusedRouteRoute,
    } as any,
  )
const AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute =
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRouteImport.update({
    id: '/rechnung/$id/is-booking',
    path: '/rechnung/$id/is-booking',
    getParentRoute: () => AuthenticatedCompanyBuchhaltungFocusedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth-error': typeof AuthErrorRoute
  '/otp-code': typeof OtpCodeRoute
  '/sign-in': typeof SignInRoute
  '/$company': typeof AuthenticatedCompanyRouteRouteWithChildren
  '/kanzlei': typeof AuthenticatedKanzleiRouteRouteWithChildren
  '/403': typeof Authenticated403Route
  '/': typeof AuthenticatedIndexRoute
  '/$company/buchhaltung': typeof AuthenticatedCompanyBuchhaltungSettingsRouteRouteWithChildren
  '/$company/unternehmen': typeof AuthenticatedCompanyUnternehmenSettingsRouteRouteWithChildren
  '/$company/doppelansicht': typeof AuthenticatedCompanyDoppelansichtRoute
  '/admin/company-setup': typeof AuthenticatedAdminCompanySetupRoute
  '/admin/mandant-erstellen': typeof AuthenticatedAdminMandantErstellenRoute
  '/kanzlei/nutzer': typeof AuthenticatedKanzleiNutzerRoute
  '/$company/': typeof AuthenticatedCompanyIndexRoute
  '/$company/buchhaltung/ausgang': typeof AuthenticatedCompanyBuchhaltungAusgangRouteRouteWithChildren
  '/$company/buchhaltung/eingang': typeof AuthenticatedCompanyBuchhaltungEingangRouteRouteWithChildren
  '/$company/buchhaltung/transaktionen': typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteWithChildren
  '/$company/unternehmen/transaktionen': typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRouteWithChildren
  '/$company/buchhaltung/ledger': typeof AuthenticatedCompanyBuchhaltungLedgerRoute
  '/$company/buchhaltung/mandant-bearbeiten': typeof AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute
  '/$company/buchhaltung/rechnungen': typeof AuthenticatedCompanyBuchhaltungRechnungenRoute
  '/$company/unternehmen/ausgangsrechnungen': typeof AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute
  '/$company/unternehmen/belege': typeof AuthenticatedCompanyUnternehmenBelegeRoute
  '/$company/unternehmen/ueberweisungen': typeof AuthenticatedCompanyUnternehmenUeberweisungenRoute
  '/$company/buchhaltung/': typeof AuthenticatedCompanyBuchhaltungIndexRoute
  '/$company/unternehmen/': typeof AuthenticatedCompanyUnternehmenIndexRoute
  '/$company/buchhaltung/ausgang/duplicates': typeof AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute
  '/$company/buchhaltung/ausgang/export': typeof AuthenticatedCompanyBuchhaltungAusgangExportRoute
  '/$company/buchhaltung/ausgang/exported': typeof AuthenticatedCompanyBuchhaltungAusgangExportedRoute
  '/$company/buchhaltung/ausgang/fastlane': typeof AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute
  '/$company/buchhaltung/ausgang/sort': typeof AuthenticatedCompanyBuchhaltungAusgangSortRoute
  '/$company/buchhaltung/ausgang/standard': typeof AuthenticatedCompanyBuchhaltungAusgangStandardRoute
  '/$company/buchhaltung/ausgang/uploads': typeof AuthenticatedCompanyBuchhaltungAusgangUploadsRoute
  '/$company/buchhaltung/eingang/duplicates': typeof AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute
  '/$company/buchhaltung/eingang/export': typeof AuthenticatedCompanyBuchhaltungEingangExportRoute
  '/$company/buchhaltung/eingang/exported': typeof AuthenticatedCompanyBuchhaltungEingangExportedRoute
  '/$company/buchhaltung/eingang/fastlane': typeof AuthenticatedCompanyBuchhaltungEingangFastlaneRoute
  '/$company/buchhaltung/eingang/sort': typeof AuthenticatedCompanyBuchhaltungEingangSortRoute
  '/$company/buchhaltung/eingang/standard': typeof AuthenticatedCompanyBuchhaltungEingangStandardRoute
  '/$company/buchhaltung/eingang/uploads': typeof AuthenticatedCompanyBuchhaltungEingangUploadsRoute
  '/$company/buchhaltung/transaktionen/export': typeof AuthenticatedCompanyBuchhaltungTransaktionenExportRoute
  '/$company/buchhaltung/transaktionen/todos': typeof AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute
  '/$company/unternehmen/transaktionen/todos': typeof AuthenticatedCompanyUnternehmenTransaktionenTodosRoute
  '/$company/buchhaltung/ausgang/': typeof AuthenticatedCompanyBuchhaltungAusgangIndexRoute
  '/$company/buchhaltung/eingang/': typeof AuthenticatedCompanyBuchhaltungEingangIndexRoute
  '/$company/buchhaltung/transaktionen/': typeof AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute
  '/$company/unternehmen/transaktionen/': typeof AuthenticatedCompanyUnternehmenTransaktionenIndexRoute
  '/$company/buchhaltung/rechnung/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute
  '/$company/buchhaltung/einstellungen/debitoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute
  '/$company/buchhaltung/einstellungen/eckdaten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute
  '/$company/buchhaltung/einstellungen/exporte': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute
  '/$company/buchhaltung/einstellungen/integrationen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute
  '/$company/buchhaltung/einstellungen/kanzleiland': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute
  '/$company/buchhaltung/einstellungen/konfiguration': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute
  '/$company/buchhaltung/einstellungen/konten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute
  '/$company/buchhaltung/einstellungen/kontenplan': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute
  '/$company/buchhaltung/einstellungen/kostenstellen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute
  '/$company/buchhaltung/einstellungen/kreditoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute
  '/$company/buchhaltung/einstellungen/weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute
  '/$company/buchhaltung/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute
  '/$company/unternehmen/bezahlen/error': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute
  '/$company/unternehmen/bezahlen/fertig': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute
  '/$company/unternehmen/transaktionen/importieren': typeof AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute
  '/$company/unternehmen/einstellungen/bank': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute
  '/$company/unternehmen/einstellungen/debitoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute
  '/$company/unternehmen/einstellungen/kostenstellen': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute
  '/$company/unternehmen/einstellungen/kreditoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute
  '/$company/unternehmen/einstellungen/weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute
  '/$company/unternehmen/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute
  '/$company/buchhaltung/einstellungen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute
  '/$company/unternehmen/bezahlen': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute
  '/$company/unternehmen/einstellungen': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute
  '/$company/unternehmen/reporting/accounts': typeof AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute
  '/$company/unternehmen/reporting/dashboard': typeof AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute
  '/$company/buchhaltung/rechnung/$id/is-booking': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute
  '/$company/buchhaltung/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute
  '/$company/unternehmen/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute
  '/$company/buchhaltung/rechnung/$id': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute
  '/$company/unternehmen/rechnung/$id': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute
}
export interface FileRoutesByTo {
  '/auth-error': typeof AuthErrorRoute
  '/otp-code': typeof OtpCodeRoute
  '/sign-in': typeof SignInRoute
  '/kanzlei': typeof AuthenticatedKanzleiRouteRouteWithChildren
  '/403': typeof Authenticated403Route
  '/': typeof AuthenticatedIndexRoute
  '/$company/doppelansicht': typeof AuthenticatedCompanyDoppelansichtRoute
  '/admin/company-setup': typeof AuthenticatedAdminCompanySetupRoute
  '/admin/mandant-erstellen': typeof AuthenticatedAdminMandantErstellenRoute
  '/kanzlei/nutzer': typeof AuthenticatedKanzleiNutzerRoute
  '/$company': typeof AuthenticatedCompanyIndexRoute
  '/$company/buchhaltung': typeof AuthenticatedCompanyBuchhaltungIndexRoute
  '/$company/unternehmen': typeof AuthenticatedCompanyUnternehmenIndexRoute
  '/$company/buchhaltung/ledger': typeof AuthenticatedCompanyBuchhaltungLedgerRoute
  '/$company/buchhaltung/mandant-bearbeiten': typeof AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute
  '/$company/buchhaltung/rechnungen': typeof AuthenticatedCompanyBuchhaltungRechnungenRoute
  '/$company/unternehmen/ausgangsrechnungen': typeof AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute
  '/$company/unternehmen/belege': typeof AuthenticatedCompanyUnternehmenBelegeRoute
  '/$company/unternehmen/ueberweisungen': typeof AuthenticatedCompanyUnternehmenUeberweisungenRoute
  '/$company/buchhaltung/ausgang/duplicates': typeof AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute
  '/$company/buchhaltung/ausgang/export': typeof AuthenticatedCompanyBuchhaltungAusgangExportRoute
  '/$company/buchhaltung/ausgang/exported': typeof AuthenticatedCompanyBuchhaltungAusgangExportedRoute
  '/$company/buchhaltung/ausgang/fastlane': typeof AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute
  '/$company/buchhaltung/ausgang/sort': typeof AuthenticatedCompanyBuchhaltungAusgangSortRoute
  '/$company/buchhaltung/ausgang/standard': typeof AuthenticatedCompanyBuchhaltungAusgangStandardRoute
  '/$company/buchhaltung/ausgang/uploads': typeof AuthenticatedCompanyBuchhaltungAusgangUploadsRoute
  '/$company/buchhaltung/eingang/duplicates': typeof AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute
  '/$company/buchhaltung/eingang/export': typeof AuthenticatedCompanyBuchhaltungEingangExportRoute
  '/$company/buchhaltung/eingang/exported': typeof AuthenticatedCompanyBuchhaltungEingangExportedRoute
  '/$company/buchhaltung/eingang/fastlane': typeof AuthenticatedCompanyBuchhaltungEingangFastlaneRoute
  '/$company/buchhaltung/eingang/sort': typeof AuthenticatedCompanyBuchhaltungEingangSortRoute
  '/$company/buchhaltung/eingang/standard': typeof AuthenticatedCompanyBuchhaltungEingangStandardRoute
  '/$company/buchhaltung/eingang/uploads': typeof AuthenticatedCompanyBuchhaltungEingangUploadsRoute
  '/$company/buchhaltung/transaktionen/export': typeof AuthenticatedCompanyBuchhaltungTransaktionenExportRoute
  '/$company/buchhaltung/transaktionen/todos': typeof AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute
  '/$company/unternehmen/transaktionen/todos': typeof AuthenticatedCompanyUnternehmenTransaktionenTodosRoute
  '/$company/buchhaltung/ausgang': typeof AuthenticatedCompanyBuchhaltungAusgangIndexRoute
  '/$company/buchhaltung/eingang': typeof AuthenticatedCompanyBuchhaltungEingangIndexRoute
  '/$company/buchhaltung/transaktionen': typeof AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute
  '/$company/unternehmen/transaktionen': typeof AuthenticatedCompanyUnternehmenTransaktionenIndexRoute
  '/$company/buchhaltung/rechnung/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute
  '/$company/buchhaltung/einstellungen/debitoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute
  '/$company/buchhaltung/einstellungen/eckdaten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute
  '/$company/buchhaltung/einstellungen/exporte': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute
  '/$company/buchhaltung/einstellungen/integrationen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute
  '/$company/buchhaltung/einstellungen/kanzleiland': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute
  '/$company/buchhaltung/einstellungen/konfiguration': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute
  '/$company/buchhaltung/einstellungen/konten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute
  '/$company/buchhaltung/einstellungen/kontenplan': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute
  '/$company/buchhaltung/einstellungen/kostenstellen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute
  '/$company/buchhaltung/einstellungen/kreditoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute
  '/$company/buchhaltung/einstellungen/weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute
  '/$company/buchhaltung/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute
  '/$company/unternehmen/bezahlen/error': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute
  '/$company/unternehmen/bezahlen/fertig': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute
  '/$company/unternehmen/transaktionen/importieren': typeof AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute
  '/$company/unternehmen/einstellungen/bank': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute
  '/$company/unternehmen/einstellungen/debitoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute
  '/$company/unternehmen/einstellungen/kostenstellen': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute
  '/$company/unternehmen/einstellungen/kreditoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute
  '/$company/unternehmen/einstellungen/weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute
  '/$company/unternehmen/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute
  '/$company/buchhaltung/einstellungen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute
  '/$company/unternehmen/bezahlen': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute
  '/$company/unternehmen/einstellungen': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute
  '/$company/unternehmen/reporting/accounts': typeof AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute
  '/$company/unternehmen/reporting/dashboard': typeof AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute
  '/$company/buchhaltung/rechnung/$id/is-booking': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute
  '/$company/buchhaltung/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute
  '/$company/unternehmen/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute
  '/$company/buchhaltung/rechnung/$id': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute
  '/$company/unternehmen/rechnung/$id': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/otp-code': typeof OtpCodeRoute
  '/sign-in': typeof SignInRoute
  '/_authenticated/$company': typeof AuthenticatedCompanyRouteRouteWithChildren
  '/_authenticated/kanzlei': typeof AuthenticatedKanzleiRouteRouteWithChildren
  '/_authenticated/403': typeof Authenticated403Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$company/buchhaltung': typeof AuthenticatedCompanyBuchhaltungRouteRouteWithChildren
  '/_authenticated/$company/unternehmen': typeof AuthenticatedCompanyUnternehmenRouteRouteWithChildren
  '/_authenticated/$company/doppelansicht': typeof AuthenticatedCompanyDoppelansichtRoute
  '/_authenticated/admin/company-setup': typeof AuthenticatedAdminCompanySetupRoute
  '/_authenticated/admin/mandant-erstellen': typeof AuthenticatedAdminMandantErstellenRoute
  '/_authenticated/kanzlei/nutzer': typeof AuthenticatedKanzleiNutzerRoute
  '/_authenticated/$company/': typeof AuthenticatedCompanyIndexRoute
  '/_authenticated/$company/buchhaltung/_focused': typeof AuthenticatedCompanyBuchhaltungFocusedRouteRouteWithChildren
  '/_authenticated/$company/buchhaltung/_settings': typeof AuthenticatedCompanyBuchhaltungSettingsRouteRouteWithChildren
  '/_authenticated/$company/buchhaltung/ausgang': typeof AuthenticatedCompanyBuchhaltungAusgangRouteRouteWithChildren
  '/_authenticated/$company/buchhaltung/eingang': typeof AuthenticatedCompanyBuchhaltungEingangRouteRouteWithChildren
  '/_authenticated/$company/buchhaltung/transaktionen': typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteWithChildren
  '/_authenticated/$company/unternehmen/_focused': typeof AuthenticatedCompanyUnternehmenFocusedRouteRouteWithChildren
  '/_authenticated/$company/unternehmen/_fullscreen': typeof AuthenticatedCompanyUnternehmenFullscreenRouteRouteWithChildren
  '/_authenticated/$company/unternehmen/_settings': typeof AuthenticatedCompanyUnternehmenSettingsRouteRouteWithChildren
  '/_authenticated/$company/unternehmen/transaktionen': typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRouteWithChildren
  '/_authenticated/$company/buchhaltung/ledger': typeof AuthenticatedCompanyBuchhaltungLedgerRoute
  '/_authenticated/$company/buchhaltung/mandant-bearbeiten': typeof AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute
  '/_authenticated/$company/buchhaltung/rechnungen': typeof AuthenticatedCompanyBuchhaltungRechnungenRoute
  '/_authenticated/$company/unternehmen/ausgangsrechnungen': typeof AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute
  '/_authenticated/$company/unternehmen/belege': typeof AuthenticatedCompanyUnternehmenBelegeRoute
  '/_authenticated/$company/unternehmen/ueberweisungen': typeof AuthenticatedCompanyUnternehmenUeberweisungenRoute
  '/_authenticated/$company/buchhaltung/': typeof AuthenticatedCompanyBuchhaltungIndexRoute
  '/_authenticated/$company/unternehmen/': typeof AuthenticatedCompanyUnternehmenIndexRoute
  '/_authenticated/$company/buchhaltung/ausgang/duplicates': typeof AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute
  '/_authenticated/$company/buchhaltung/ausgang/export': typeof AuthenticatedCompanyBuchhaltungAusgangExportRoute
  '/_authenticated/$company/buchhaltung/ausgang/exported': typeof AuthenticatedCompanyBuchhaltungAusgangExportedRoute
  '/_authenticated/$company/buchhaltung/ausgang/fastlane': typeof AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute
  '/_authenticated/$company/buchhaltung/ausgang/sort': typeof AuthenticatedCompanyBuchhaltungAusgangSortRoute
  '/_authenticated/$company/buchhaltung/ausgang/standard': typeof AuthenticatedCompanyBuchhaltungAusgangStandardRoute
  '/_authenticated/$company/buchhaltung/ausgang/uploads': typeof AuthenticatedCompanyBuchhaltungAusgangUploadsRoute
  '/_authenticated/$company/buchhaltung/eingang/duplicates': typeof AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute
  '/_authenticated/$company/buchhaltung/eingang/export': typeof AuthenticatedCompanyBuchhaltungEingangExportRoute
  '/_authenticated/$company/buchhaltung/eingang/exported': typeof AuthenticatedCompanyBuchhaltungEingangExportedRoute
  '/_authenticated/$company/buchhaltung/eingang/fastlane': typeof AuthenticatedCompanyBuchhaltungEingangFastlaneRoute
  '/_authenticated/$company/buchhaltung/eingang/sort': typeof AuthenticatedCompanyBuchhaltungEingangSortRoute
  '/_authenticated/$company/buchhaltung/eingang/standard': typeof AuthenticatedCompanyBuchhaltungEingangStandardRoute
  '/_authenticated/$company/buchhaltung/eingang/uploads': typeof AuthenticatedCompanyBuchhaltungEingangUploadsRoute
  '/_authenticated/$company/buchhaltung/transaktionen/export': typeof AuthenticatedCompanyBuchhaltungTransaktionenExportRoute
  '/_authenticated/$company/buchhaltung/transaktionen/todos': typeof AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute
  '/_authenticated/$company/unternehmen/transaktionen/todos': typeof AuthenticatedCompanyUnternehmenTransaktionenTodosRoute
  '/_authenticated/$company/buchhaltung/ausgang/': typeof AuthenticatedCompanyBuchhaltungAusgangIndexRoute
  '/_authenticated/$company/buchhaltung/eingang/': typeof AuthenticatedCompanyBuchhaltungEingangIndexRoute
  '/_authenticated/$company/buchhaltung/transaktionen/': typeof AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute
  '/_authenticated/$company/unternehmen/transaktionen/': typeof AuthenticatedCompanyUnternehmenTransaktionenIndexRoute
  '/_authenticated/$company/buchhaltung/_focused/rechnung/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/debitoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/konten': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/kostenstellen': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute
  '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/error': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute
  '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute
  '/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren': typeof AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/bank': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/kreditoren': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute
  '/_authenticated/$company/buchhaltung/_settings/einstellungen/': typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute
  '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/': typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute
  '/_authenticated/$company/unternehmen/_settings/einstellungen/': typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute
  '/_authenticated/$company/unternehmen/reporting/accounts/': typeof AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute
  '/_authenticated/$company/unternehmen/reporting/dashboard/': typeof AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute
  '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute
  '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute
  '/_authenticated/$company/unternehmen/_focused/rechnung/$id/seiten-bearbeiten': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute
  '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/': typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute
  '/_authenticated/$company/unternehmen/_focused/rechnung/$id/': typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth-error'
    | '/otp-code'
    | '/sign-in'
    | '/$company'
    | '/kanzlei'
    | '/403'
    | '/'
    | '/$company/buchhaltung'
    | '/$company/unternehmen'
    | '/$company/doppelansicht'
    | '/admin/company-setup'
    | '/admin/mandant-erstellen'
    | '/kanzlei/nutzer'
    | '/$company/'
    | '/$company/buchhaltung/ausgang'
    | '/$company/buchhaltung/eingang'
    | '/$company/buchhaltung/transaktionen'
    | '/$company/unternehmen/transaktionen'
    | '/$company/buchhaltung/ledger'
    | '/$company/buchhaltung/mandant-bearbeiten'
    | '/$company/buchhaltung/rechnungen'
    | '/$company/unternehmen/ausgangsrechnungen'
    | '/$company/unternehmen/belege'
    | '/$company/unternehmen/ueberweisungen'
    | '/$company/buchhaltung/'
    | '/$company/unternehmen/'
    | '/$company/buchhaltung/ausgang/duplicates'
    | '/$company/buchhaltung/ausgang/export'
    | '/$company/buchhaltung/ausgang/exported'
    | '/$company/buchhaltung/ausgang/fastlane'
    | '/$company/buchhaltung/ausgang/sort'
    | '/$company/buchhaltung/ausgang/standard'
    | '/$company/buchhaltung/ausgang/uploads'
    | '/$company/buchhaltung/eingang/duplicates'
    | '/$company/buchhaltung/eingang/export'
    | '/$company/buchhaltung/eingang/exported'
    | '/$company/buchhaltung/eingang/fastlane'
    | '/$company/buchhaltung/eingang/sort'
    | '/$company/buchhaltung/eingang/standard'
    | '/$company/buchhaltung/eingang/uploads'
    | '/$company/buchhaltung/transaktionen/export'
    | '/$company/buchhaltung/transaktionen/todos'
    | '/$company/unternehmen/transaktionen/todos'
    | '/$company/buchhaltung/ausgang/'
    | '/$company/buchhaltung/eingang/'
    | '/$company/buchhaltung/transaktionen/'
    | '/$company/unternehmen/transaktionen/'
    | '/$company/buchhaltung/rechnung/seiten-bearbeiten'
    | '/$company/buchhaltung/einstellungen/debitoren'
    | '/$company/buchhaltung/einstellungen/eckdaten'
    | '/$company/buchhaltung/einstellungen/exporte'
    | '/$company/buchhaltung/einstellungen/integrationen'
    | '/$company/buchhaltung/einstellungen/kanzleiland'
    | '/$company/buchhaltung/einstellungen/konfiguration'
    | '/$company/buchhaltung/einstellungen/konten'
    | '/$company/buchhaltung/einstellungen/kontenplan'
    | '/$company/buchhaltung/einstellungen/kostenstellen'
    | '/$company/buchhaltung/einstellungen/kreditoren'
    | '/$company/buchhaltung/einstellungen/weiterleitung'
    | '/$company/buchhaltung/einstellungen/whatsapp-weiterleitung'
    | '/$company/unternehmen/bezahlen/error'
    | '/$company/unternehmen/bezahlen/fertig'
    | '/$company/unternehmen/transaktionen/importieren'
    | '/$company/unternehmen/einstellungen/bank'
    | '/$company/unternehmen/einstellungen/debitoren'
    | '/$company/unternehmen/einstellungen/kostenstellen'
    | '/$company/unternehmen/einstellungen/kreditoren'
    | '/$company/unternehmen/einstellungen/weiterleitung'
    | '/$company/unternehmen/einstellungen/whatsapp-weiterleitung'
    | '/$company/buchhaltung/einstellungen'
    | '/$company/unternehmen/bezahlen'
    | '/$company/unternehmen/einstellungen'
    | '/$company/unternehmen/reporting/accounts'
    | '/$company/unternehmen/reporting/dashboard'
    | '/$company/buchhaltung/rechnung/$id/is-booking'
    | '/$company/buchhaltung/rechnung/$id/seiten-bearbeiten'
    | '/$company/unternehmen/rechnung/$id/seiten-bearbeiten'
    | '/$company/buchhaltung/rechnung/$id'
    | '/$company/unternehmen/rechnung/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth-error'
    | '/otp-code'
    | '/sign-in'
    | '/kanzlei'
    | '/403'
    | '/'
    | '/$company/doppelansicht'
    | '/admin/company-setup'
    | '/admin/mandant-erstellen'
    | '/kanzlei/nutzer'
    | '/$company'
    | '/$company/buchhaltung'
    | '/$company/unternehmen'
    | '/$company/buchhaltung/ledger'
    | '/$company/buchhaltung/mandant-bearbeiten'
    | '/$company/buchhaltung/rechnungen'
    | '/$company/unternehmen/ausgangsrechnungen'
    | '/$company/unternehmen/belege'
    | '/$company/unternehmen/ueberweisungen'
    | '/$company/buchhaltung/ausgang/duplicates'
    | '/$company/buchhaltung/ausgang/export'
    | '/$company/buchhaltung/ausgang/exported'
    | '/$company/buchhaltung/ausgang/fastlane'
    | '/$company/buchhaltung/ausgang/sort'
    | '/$company/buchhaltung/ausgang/standard'
    | '/$company/buchhaltung/ausgang/uploads'
    | '/$company/buchhaltung/eingang/duplicates'
    | '/$company/buchhaltung/eingang/export'
    | '/$company/buchhaltung/eingang/exported'
    | '/$company/buchhaltung/eingang/fastlane'
    | '/$company/buchhaltung/eingang/sort'
    | '/$company/buchhaltung/eingang/standard'
    | '/$company/buchhaltung/eingang/uploads'
    | '/$company/buchhaltung/transaktionen/export'
    | '/$company/buchhaltung/transaktionen/todos'
    | '/$company/unternehmen/transaktionen/todos'
    | '/$company/buchhaltung/ausgang'
    | '/$company/buchhaltung/eingang'
    | '/$company/buchhaltung/transaktionen'
    | '/$company/unternehmen/transaktionen'
    | '/$company/buchhaltung/rechnung/seiten-bearbeiten'
    | '/$company/buchhaltung/einstellungen/debitoren'
    | '/$company/buchhaltung/einstellungen/eckdaten'
    | '/$company/buchhaltung/einstellungen/exporte'
    | '/$company/buchhaltung/einstellungen/integrationen'
    | '/$company/buchhaltung/einstellungen/kanzleiland'
    | '/$company/buchhaltung/einstellungen/konfiguration'
    | '/$company/buchhaltung/einstellungen/konten'
    | '/$company/buchhaltung/einstellungen/kontenplan'
    | '/$company/buchhaltung/einstellungen/kostenstellen'
    | '/$company/buchhaltung/einstellungen/kreditoren'
    | '/$company/buchhaltung/einstellungen/weiterleitung'
    | '/$company/buchhaltung/einstellungen/whatsapp-weiterleitung'
    | '/$company/unternehmen/bezahlen/error'
    | '/$company/unternehmen/bezahlen/fertig'
    | '/$company/unternehmen/transaktionen/importieren'
    | '/$company/unternehmen/einstellungen/bank'
    | '/$company/unternehmen/einstellungen/debitoren'
    | '/$company/unternehmen/einstellungen/kostenstellen'
    | '/$company/unternehmen/einstellungen/kreditoren'
    | '/$company/unternehmen/einstellungen/weiterleitung'
    | '/$company/unternehmen/einstellungen/whatsapp-weiterleitung'
    | '/$company/buchhaltung/einstellungen'
    | '/$company/unternehmen/bezahlen'
    | '/$company/unternehmen/einstellungen'
    | '/$company/unternehmen/reporting/accounts'
    | '/$company/unternehmen/reporting/dashboard'
    | '/$company/buchhaltung/rechnung/$id/is-booking'
    | '/$company/buchhaltung/rechnung/$id/seiten-bearbeiten'
    | '/$company/unternehmen/rechnung/$id/seiten-bearbeiten'
    | '/$company/buchhaltung/rechnung/$id'
    | '/$company/unternehmen/rechnung/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth-error'
    | '/otp-code'
    | '/sign-in'
    | '/_authenticated/$company'
    | '/_authenticated/kanzlei'
    | '/_authenticated/403'
    | '/_authenticated/'
    | '/_authenticated/$company/buchhaltung'
    | '/_authenticated/$company/unternehmen'
    | '/_authenticated/$company/doppelansicht'
    | '/_authenticated/admin/company-setup'
    | '/_authenticated/admin/mandant-erstellen'
    | '/_authenticated/kanzlei/nutzer'
    | '/_authenticated/$company/'
    | '/_authenticated/$company/buchhaltung/_focused'
    | '/_authenticated/$company/buchhaltung/_settings'
    | '/_authenticated/$company/buchhaltung/ausgang'
    | '/_authenticated/$company/buchhaltung/eingang'
    | '/_authenticated/$company/buchhaltung/transaktionen'
    | '/_authenticated/$company/unternehmen/_focused'
    | '/_authenticated/$company/unternehmen/_fullscreen'
    | '/_authenticated/$company/unternehmen/_settings'
    | '/_authenticated/$company/unternehmen/transaktionen'
    | '/_authenticated/$company/buchhaltung/ledger'
    | '/_authenticated/$company/buchhaltung/mandant-bearbeiten'
    | '/_authenticated/$company/buchhaltung/rechnungen'
    | '/_authenticated/$company/unternehmen/ausgangsrechnungen'
    | '/_authenticated/$company/unternehmen/belege'
    | '/_authenticated/$company/unternehmen/ueberweisungen'
    | '/_authenticated/$company/buchhaltung/'
    | '/_authenticated/$company/unternehmen/'
    | '/_authenticated/$company/buchhaltung/ausgang/duplicates'
    | '/_authenticated/$company/buchhaltung/ausgang/export'
    | '/_authenticated/$company/buchhaltung/ausgang/exported'
    | '/_authenticated/$company/buchhaltung/ausgang/fastlane'
    | '/_authenticated/$company/buchhaltung/ausgang/sort'
    | '/_authenticated/$company/buchhaltung/ausgang/standard'
    | '/_authenticated/$company/buchhaltung/ausgang/uploads'
    | '/_authenticated/$company/buchhaltung/eingang/duplicates'
    | '/_authenticated/$company/buchhaltung/eingang/export'
    | '/_authenticated/$company/buchhaltung/eingang/exported'
    | '/_authenticated/$company/buchhaltung/eingang/fastlane'
    | '/_authenticated/$company/buchhaltung/eingang/sort'
    | '/_authenticated/$company/buchhaltung/eingang/standard'
    | '/_authenticated/$company/buchhaltung/eingang/uploads'
    | '/_authenticated/$company/buchhaltung/transaktionen/export'
    | '/_authenticated/$company/buchhaltung/transaktionen/todos'
    | '/_authenticated/$company/unternehmen/transaktionen/todos'
    | '/_authenticated/$company/buchhaltung/ausgang/'
    | '/_authenticated/$company/buchhaltung/eingang/'
    | '/_authenticated/$company/buchhaltung/transaktionen/'
    | '/_authenticated/$company/unternehmen/transaktionen/'
    | '/_authenticated/$company/buchhaltung/_focused/rechnung/seiten-bearbeiten'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/debitoren'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/konten'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/kostenstellen'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/weiterleitung'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung'
    | '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/error'
    | '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig'
    | '/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/bank'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/kreditoren'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung'
    | '/_authenticated/$company/buchhaltung/_settings/einstellungen/'
    | '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/'
    | '/_authenticated/$company/unternehmen/_settings/einstellungen/'
    | '/_authenticated/$company/unternehmen/reporting/accounts/'
    | '/_authenticated/$company/unternehmen/reporting/dashboard/'
    | '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking'
    | '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/seiten-bearbeiten'
    | '/_authenticated/$company/unternehmen/_focused/rechnung/$id/seiten-bearbeiten'
    | '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/'
    | '/_authenticated/$company/unternehmen/_focused/rechnung/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthErrorRoute: typeof AuthErrorRoute
  OtpCodeRoute: typeof OtpCodeRoute
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp-code': {
      id: '/otp-code'
      path: '/otp-code'
      fullPath: '/otp-code'
      preLoaderRoute: typeof OtpCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-error': {
      id: '/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/403': {
      id: '/_authenticated/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Authenticated403RouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kanzlei': {
      id: '/_authenticated/kanzlei'
      path: '/kanzlei'
      fullPath: '/kanzlei'
      preLoaderRoute: typeof AuthenticatedKanzleiRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$company': {
      id: '/_authenticated/$company'
      path: '/$company'
      fullPath: '/$company'
      preLoaderRoute: typeof AuthenticatedCompanyRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$company/': {
      id: '/_authenticated/$company/'
      path: '/'
      fullPath: '/$company/'
      preLoaderRoute: typeof AuthenticatedCompanyIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/kanzlei/nutzer': {
      id: '/_authenticated/kanzlei/nutzer'
      path: '/nutzer'
      fullPath: '/kanzlei/nutzer'
      preLoaderRoute: typeof AuthenticatedKanzleiNutzerRouteImport
      parentRoute: typeof AuthenticatedKanzleiRouteRoute
    }
    '/_authenticated/admin/mandant-erstellen': {
      id: '/_authenticated/admin/mandant-erstellen'
      path: '/admin/mandant-erstellen'
      fullPath: '/admin/mandant-erstellen'
      preLoaderRoute: typeof AuthenticatedAdminMandantErstellenRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/company-setup': {
      id: '/_authenticated/admin/company-setup'
      path: '/admin/company-setup'
      fullPath: '/admin/company-setup'
      preLoaderRoute: typeof AuthenticatedAdminCompanySetupRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$company/doppelansicht': {
      id: '/_authenticated/$company/doppelansicht'
      path: '/doppelansicht'
      fullPath: '/$company/doppelansicht'
      preLoaderRoute: typeof AuthenticatedCompanyDoppelansichtRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/$company/unternehmen': {
      id: '/_authenticated/$company/unternehmen'
      path: '/unternehmen'
      fullPath: '/$company/unternehmen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/$company/buchhaltung': {
      id: '/_authenticated/$company/buchhaltung'
      path: '/buchhaltung'
      fullPath: '/$company/buchhaltung'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/$company/unternehmen/': {
      id: '/_authenticated/$company/unternehmen/'
      path: '/'
      fullPath: '/$company/unternehmen/'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/': {
      id: '/_authenticated/$company/buchhaltung/'
      path: '/'
      fullPath: '/$company/buchhaltung/'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/unternehmen/ueberweisungen': {
      id: '/_authenticated/$company/unternehmen/ueberweisungen'
      path: '/ueberweisungen'
      fullPath: '/$company/unternehmen/ueberweisungen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenUeberweisungenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/belege': {
      id: '/_authenticated/$company/unternehmen/belege'
      path: '/belege'
      fullPath: '/$company/unternehmen/belege'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenBelegeRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/ausgangsrechnungen': {
      id: '/_authenticated/$company/unternehmen/ausgangsrechnungen'
      path: '/ausgangsrechnungen'
      fullPath: '/$company/unternehmen/ausgangsrechnungen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenAusgangsrechnungenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/rechnungen': {
      id: '/_authenticated/$company/buchhaltung/rechnungen'
      path: '/rechnungen'
      fullPath: '/$company/buchhaltung/rechnungen'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungRechnungenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/mandant-bearbeiten': {
      id: '/_authenticated/$company/buchhaltung/mandant-bearbeiten'
      path: '/mandant-bearbeiten'
      fullPath: '/$company/buchhaltung/mandant-bearbeiten'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungMandantBearbeitenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ledger': {
      id: '/_authenticated/$company/buchhaltung/ledger'
      path: '/ledger'
      fullPath: '/$company/buchhaltung/ledger'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungLedgerRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/unternehmen/transaktionen': {
      id: '/_authenticated/$company/unternehmen/transaktionen'
      path: '/transaktionen'
      fullPath: '/$company/unternehmen/transaktionen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings': {
      id: '/_authenticated/$company/unternehmen/_settings'
      path: ''
      fullPath: '/$company/unternehmen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_fullscreen': {
      id: '/_authenticated/$company/unternehmen/_fullscreen'
      path: ''
      fullPath: '/$company/unternehmen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_focused': {
      id: '/_authenticated/$company/unternehmen/_focused'
      path: ''
      fullPath: '/$company/unternehmen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFocusedRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/transaktionen': {
      id: '/_authenticated/$company/buchhaltung/transaktionen'
      path: '/transaktionen'
      fullPath: '/$company/buchhaltung/transaktionen'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang': {
      id: '/_authenticated/$company/buchhaltung/eingang'
      path: '/eingang'
      fullPath: '/$company/buchhaltung/eingang'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang': {
      id: '/_authenticated/$company/buchhaltung/ausgang'
      path: '/ausgang'
      fullPath: '/$company/buchhaltung/ausgang'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings': {
      id: '/_authenticated/$company/buchhaltung/_settings'
      path: ''
      fullPath: '/$company/buchhaltung'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_focused': {
      id: '/_authenticated/$company/buchhaltung/_focused'
      path: ''
      fullPath: '/$company/buchhaltung'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungRouteRoute
    }
    '/_authenticated/$company/unternehmen/transaktionen/': {
      id: '/_authenticated/$company/unternehmen/transaktionen/'
      path: '/'
      fullPath: '/$company/unternehmen/transaktionen/'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/transaktionen/': {
      id: '/_authenticated/$company/buchhaltung/transaktionen/'
      path: '/'
      fullPath: '/$company/buchhaltung/transaktionen/'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/': {
      id: '/_authenticated/$company/buchhaltung/eingang/'
      path: '/'
      fullPath: '/$company/buchhaltung/eingang/'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/': {
      id: '/_authenticated/$company/buchhaltung/ausgang/'
      path: '/'
      fullPath: '/$company/buchhaltung/ausgang/'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/unternehmen/transaktionen/todos': {
      id: '/_authenticated/$company/unternehmen/transaktionen/todos'
      path: '/todos'
      fullPath: '/$company/unternehmen/transaktionen/todos'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenTodosRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/transaktionen/todos': {
      id: '/_authenticated/$company/buchhaltung/transaktionen/todos'
      path: '/todos'
      fullPath: '/$company/buchhaltung/transaktionen/todos'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenTodosRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/transaktionen/export': {
      id: '/_authenticated/$company/buchhaltung/transaktionen/export'
      path: '/export'
      fullPath: '/$company/buchhaltung/transaktionen/export'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenExportRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/uploads': {
      id: '/_authenticated/$company/buchhaltung/eingang/uploads'
      path: '/uploads'
      fullPath: '/$company/buchhaltung/eingang/uploads'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangUploadsRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/standard': {
      id: '/_authenticated/$company/buchhaltung/eingang/standard'
      path: '/standard'
      fullPath: '/$company/buchhaltung/eingang/standard'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangStandardRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/sort': {
      id: '/_authenticated/$company/buchhaltung/eingang/sort'
      path: '/sort'
      fullPath: '/$company/buchhaltung/eingang/sort'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangSortRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/fastlane': {
      id: '/_authenticated/$company/buchhaltung/eingang/fastlane'
      path: '/fastlane'
      fullPath: '/$company/buchhaltung/eingang/fastlane'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangFastlaneRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/exported': {
      id: '/_authenticated/$company/buchhaltung/eingang/exported'
      path: '/exported'
      fullPath: '/$company/buchhaltung/eingang/exported'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangExportedRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/export': {
      id: '/_authenticated/$company/buchhaltung/eingang/export'
      path: '/export'
      fullPath: '/$company/buchhaltung/eingang/export'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangExportRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/eingang/duplicates': {
      id: '/_authenticated/$company/buchhaltung/eingang/duplicates'
      path: '/duplicates'
      fullPath: '/$company/buchhaltung/eingang/duplicates'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungEingangDuplicatesRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/uploads': {
      id: '/_authenticated/$company/buchhaltung/ausgang/uploads'
      path: '/uploads'
      fullPath: '/$company/buchhaltung/ausgang/uploads'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangUploadsRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/standard': {
      id: '/_authenticated/$company/buchhaltung/ausgang/standard'
      path: '/standard'
      fullPath: '/$company/buchhaltung/ausgang/standard'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangStandardRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/sort': {
      id: '/_authenticated/$company/buchhaltung/ausgang/sort'
      path: '/sort'
      fullPath: '/$company/buchhaltung/ausgang/sort'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangSortRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/fastlane': {
      id: '/_authenticated/$company/buchhaltung/ausgang/fastlane'
      path: '/fastlane'
      fullPath: '/$company/buchhaltung/ausgang/fastlane'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangFastlaneRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/exported': {
      id: '/_authenticated/$company/buchhaltung/ausgang/exported'
      path: '/exported'
      fullPath: '/$company/buchhaltung/ausgang/exported'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangExportedRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/export': {
      id: '/_authenticated/$company/buchhaltung/ausgang/export'
      path: '/export'
      fullPath: '/$company/buchhaltung/ausgang/export'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangExportRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/buchhaltung/ausgang/duplicates': {
      id: '/_authenticated/$company/buchhaltung/ausgang/duplicates'
      path: '/duplicates'
      fullPath: '/$company/buchhaltung/ausgang/duplicates'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungAusgangDuplicatesRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRoute
    }
    '/_authenticated/$company/unternehmen/reporting/dashboard/': {
      id: '/_authenticated/$company/unternehmen/reporting/dashboard/'
      path: '/reporting/dashboard'
      fullPath: '/$company/unternehmen/reporting/dashboard'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenReportingDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/reporting/accounts/': {
      id: '/_authenticated/$company/unternehmen/reporting/accounts/'
      path: '/reporting/accounts'
      fullPath: '/$company/unternehmen/reporting/accounts'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenReportingAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/'
      path: '/einstellungen'
      fullPath: '/$company/unternehmen/einstellungen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/': {
      id: '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/'
      path: '/bezahlen'
      fullPath: '/$company/unternehmen/bezahlen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/'
      path: '/einstellungen'
      fullPath: '/$company/buchhaltung/einstellungen'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/whatsapp-weiterleitung'
      path: '/einstellungen/whatsapp-weiterleitung'
      fullPath: '/$company/unternehmen/einstellungen/whatsapp-weiterleitung'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung'
      path: '/einstellungen/weiterleitung'
      fullPath: '/$company/unternehmen/einstellungen/weiterleitung'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/kreditoren': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/kreditoren'
      path: '/einstellungen/kreditoren'
      fullPath: '/$company/unternehmen/einstellungen/kreditoren'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/kostenstellen'
      path: '/einstellungen/kostenstellen'
      fullPath: '/$company/unternehmen/einstellungen/kostenstellen'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren'
      path: '/einstellungen/debitoren'
      fullPath: '/$company/unternehmen/einstellungen/debitoren'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_settings/einstellungen/bank': {
      id: '/_authenticated/$company/unternehmen/_settings/einstellungen/bank'
      path: '/einstellungen/bank'
      fullPath: '/$company/unternehmen/einstellungen/bank'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRoute
    }
    '/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren': {
      id: '/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren'
      path: '/transaktionen/importieren'
      fullPath: '/$company/unternehmen/transaktionen/importieren'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig': {
      id: '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig'
      path: '/bezahlen/fertig'
      fullPath: '/$company/unternehmen/bezahlen/fertig'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRoute
    }
    '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/error': {
      id: '/_authenticated/$company/unternehmen/_fullscreen/bezahlen/error'
      path: '/bezahlen/error'
      fullPath: '/$company/unternehmen/bezahlen/error'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung'
      path: '/einstellungen/whatsapp-weiterleitung'
      fullPath: '/$company/buchhaltung/einstellungen/whatsapp-weiterleitung'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/weiterleitung': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/weiterleitung'
      path: '/einstellungen/weiterleitung'
      fullPath: '/$company/buchhaltung/einstellungen/weiterleitung'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/kreditoren'
      path: '/einstellungen/kreditoren'
      fullPath: '/$company/buchhaltung/einstellungen/kreditoren'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/kostenstellen': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/kostenstellen'
      path: '/einstellungen/kostenstellen'
      fullPath: '/$company/buchhaltung/einstellungen/kostenstellen'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/kontenplan'
      path: '/einstellungen/kontenplan'
      fullPath: '/$company/buchhaltung/einstellungen/kontenplan'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/konten': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/konten'
      path: '/einstellungen/konten'
      fullPath: '/$company/buchhaltung/einstellungen/konten'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/konfiguration'
      path: '/einstellungen/konfiguration'
      fullPath: '/$company/buchhaltung/einstellungen/konfiguration'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland'
      path: '/einstellungen/kanzleiland'
      fullPath: '/$company/buchhaltung/einstellungen/kanzleiland'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/integrationen'
      path: '/einstellungen/integrationen'
      fullPath: '/$company/buchhaltung/einstellungen/integrationen'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte'
      path: '/einstellungen/exporte'
      fullPath: '/$company/buchhaltung/einstellungen/exporte'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten'
      path: '/einstellungen/eckdaten'
      fullPath: '/$company/buchhaltung/einstellungen/eckdaten'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_settings/einstellungen/debitoren': {
      id: '/_authenticated/$company/buchhaltung/_settings/einstellungen/debitoren'
      path: '/einstellungen/debitoren'
      fullPath: '/$company/buchhaltung/einstellungen/debitoren'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_focused/rechnung/seiten-bearbeiten': {
      id: '/_authenticated/$company/buchhaltung/_focused/rechnung/seiten-bearbeiten'
      path: '/rechnung/seiten-bearbeiten'
      fullPath: '/$company/buchhaltung/rechnung/seiten-bearbeiten'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRoute
    }
    '/_authenticated/$company/unternehmen/_focused/rechnung/$id/': {
      id: '/_authenticated/$company/unternehmen/_focused/rechnung/$id/'
      path: '/rechnung/$id'
      fullPath: '/$company/unternehmen/rechnung/$id'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFocusedRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/': {
      id: '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/'
      path: '/rechnung/$id'
      fullPath: '/$company/buchhaltung/rechnung/$id'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRoute
    }
    '/_authenticated/$company/unternehmen/_focused/rechnung/$id/seiten-bearbeiten': {
      id: '/_authenticated/$company/unternehmen/_focused/rechnung/$id/seiten-bearbeiten'
      path: '/rechnung/$id/seiten-bearbeiten'
      fullPath: '/$company/unternehmen/rechnung/$id/seiten-bearbeiten'
      preLoaderRoute: typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRouteImport
      parentRoute: typeof AuthenticatedCompanyUnternehmenFocusedRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/seiten-bearbeiten': {
      id: '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/seiten-bearbeiten'
      path: '/rechnung/$id/seiten-bearbeiten'
      fullPath: '/$company/buchhaltung/rechnung/$id/seiten-bearbeiten'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRoute
    }
    '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking': {
      id: '/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking'
      path: '/rechnung/$id/is-booking'
      fullPath: '/$company/buchhaltung/rechnung/$id/is-booking'
      preLoaderRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRouteImport
      parentRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRoute
    }
  }
}

interface AuthenticatedCompanyBuchhaltungFocusedRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute
  AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute
}

const AuthenticatedCompanyBuchhaltungFocusedRouteRouteChildren: AuthenticatedCompanyBuchhaltungFocusedRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute:
      AuthenticatedCompanyBuchhaltungFocusedRechnungSeitenBearbeitenRoute,
    AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute:
      AuthenticatedCompanyBuchhaltungFocusedRechnungIdIsBookingRoute,
    AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute:
      AuthenticatedCompanyBuchhaltungFocusedRechnungIdSeitenBearbeitenRoute,
    AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute:
      AuthenticatedCompanyBuchhaltungFocusedRechnungIdIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungFocusedRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungFocusedRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungFocusedRouteRouteChildren,
  )

interface AuthenticatedCompanyBuchhaltungSettingsRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute
  AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute: typeof AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute
}

const AuthenticatedCompanyBuchhaltungSettingsRouteRouteChildren: AuthenticatedCompanyBuchhaltungSettingsRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenDebitorenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenEckdatenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenExporteRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenIntegrationenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKanzleilandRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKonfigurationRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKontenplanRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKostenstellenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenKreditorenRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenWeiterleitungRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenWhatsappWeiterleitungRoute,
    AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute:
      AuthenticatedCompanyBuchhaltungSettingsEinstellungenIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungSettingsRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungSettingsRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungSettingsRouteRouteChildren,
  )

interface AuthenticatedCompanyBuchhaltungAusgangRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute: typeof AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute
  AuthenticatedCompanyBuchhaltungAusgangExportRoute: typeof AuthenticatedCompanyBuchhaltungAusgangExportRoute
  AuthenticatedCompanyBuchhaltungAusgangExportedRoute: typeof AuthenticatedCompanyBuchhaltungAusgangExportedRoute
  AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute: typeof AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute
  AuthenticatedCompanyBuchhaltungAusgangSortRoute: typeof AuthenticatedCompanyBuchhaltungAusgangSortRoute
  AuthenticatedCompanyBuchhaltungAusgangStandardRoute: typeof AuthenticatedCompanyBuchhaltungAusgangStandardRoute
  AuthenticatedCompanyBuchhaltungAusgangUploadsRoute: typeof AuthenticatedCompanyBuchhaltungAusgangUploadsRoute
  AuthenticatedCompanyBuchhaltungAusgangIndexRoute: typeof AuthenticatedCompanyBuchhaltungAusgangIndexRoute
}

const AuthenticatedCompanyBuchhaltungAusgangRouteRouteChildren: AuthenticatedCompanyBuchhaltungAusgangRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute:
      AuthenticatedCompanyBuchhaltungAusgangDuplicatesRoute,
    AuthenticatedCompanyBuchhaltungAusgangExportRoute:
      AuthenticatedCompanyBuchhaltungAusgangExportRoute,
    AuthenticatedCompanyBuchhaltungAusgangExportedRoute:
      AuthenticatedCompanyBuchhaltungAusgangExportedRoute,
    AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute:
      AuthenticatedCompanyBuchhaltungAusgangFastlaneRoute,
    AuthenticatedCompanyBuchhaltungAusgangSortRoute:
      AuthenticatedCompanyBuchhaltungAusgangSortRoute,
    AuthenticatedCompanyBuchhaltungAusgangStandardRoute:
      AuthenticatedCompanyBuchhaltungAusgangStandardRoute,
    AuthenticatedCompanyBuchhaltungAusgangUploadsRoute:
      AuthenticatedCompanyBuchhaltungAusgangUploadsRoute,
    AuthenticatedCompanyBuchhaltungAusgangIndexRoute:
      AuthenticatedCompanyBuchhaltungAusgangIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungAusgangRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungAusgangRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungAusgangRouteRouteChildren,
  )

interface AuthenticatedCompanyBuchhaltungEingangRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute: typeof AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute
  AuthenticatedCompanyBuchhaltungEingangExportRoute: typeof AuthenticatedCompanyBuchhaltungEingangExportRoute
  AuthenticatedCompanyBuchhaltungEingangExportedRoute: typeof AuthenticatedCompanyBuchhaltungEingangExportedRoute
  AuthenticatedCompanyBuchhaltungEingangFastlaneRoute: typeof AuthenticatedCompanyBuchhaltungEingangFastlaneRoute
  AuthenticatedCompanyBuchhaltungEingangSortRoute: typeof AuthenticatedCompanyBuchhaltungEingangSortRoute
  AuthenticatedCompanyBuchhaltungEingangStandardRoute: typeof AuthenticatedCompanyBuchhaltungEingangStandardRoute
  AuthenticatedCompanyBuchhaltungEingangUploadsRoute: typeof AuthenticatedCompanyBuchhaltungEingangUploadsRoute
  AuthenticatedCompanyBuchhaltungEingangIndexRoute: typeof AuthenticatedCompanyBuchhaltungEingangIndexRoute
}

const AuthenticatedCompanyBuchhaltungEingangRouteRouteChildren: AuthenticatedCompanyBuchhaltungEingangRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute:
      AuthenticatedCompanyBuchhaltungEingangDuplicatesRoute,
    AuthenticatedCompanyBuchhaltungEingangExportRoute:
      AuthenticatedCompanyBuchhaltungEingangExportRoute,
    AuthenticatedCompanyBuchhaltungEingangExportedRoute:
      AuthenticatedCompanyBuchhaltungEingangExportedRoute,
    AuthenticatedCompanyBuchhaltungEingangFastlaneRoute:
      AuthenticatedCompanyBuchhaltungEingangFastlaneRoute,
    AuthenticatedCompanyBuchhaltungEingangSortRoute:
      AuthenticatedCompanyBuchhaltungEingangSortRoute,
    AuthenticatedCompanyBuchhaltungEingangStandardRoute:
      AuthenticatedCompanyBuchhaltungEingangStandardRoute,
    AuthenticatedCompanyBuchhaltungEingangUploadsRoute:
      AuthenticatedCompanyBuchhaltungEingangUploadsRoute,
    AuthenticatedCompanyBuchhaltungEingangIndexRoute:
      AuthenticatedCompanyBuchhaltungEingangIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungEingangRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungEingangRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungEingangRouteRouteChildren,
  )

interface AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungTransaktionenExportRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenExportRoute
  AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute
  AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute
}

const AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteChildren: AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungTransaktionenExportRoute:
      AuthenticatedCompanyBuchhaltungTransaktionenExportRoute,
    AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute:
      AuthenticatedCompanyBuchhaltungTransaktionenTodosRoute,
    AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute:
      AuthenticatedCompanyBuchhaltungTransaktionenIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteChildren,
  )

interface AuthenticatedCompanyBuchhaltungRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungFocusedRouteRoute: typeof AuthenticatedCompanyBuchhaltungFocusedRouteRouteWithChildren
  AuthenticatedCompanyBuchhaltungSettingsRouteRoute: typeof AuthenticatedCompanyBuchhaltungSettingsRouteRouteWithChildren
  AuthenticatedCompanyBuchhaltungAusgangRouteRoute: typeof AuthenticatedCompanyBuchhaltungAusgangRouteRouteWithChildren
  AuthenticatedCompanyBuchhaltungEingangRouteRoute: typeof AuthenticatedCompanyBuchhaltungEingangRouteRouteWithChildren
  AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute: typeof AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteWithChildren
  AuthenticatedCompanyBuchhaltungLedgerRoute: typeof AuthenticatedCompanyBuchhaltungLedgerRoute
  AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute: typeof AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute
  AuthenticatedCompanyBuchhaltungRechnungenRoute: typeof AuthenticatedCompanyBuchhaltungRechnungenRoute
  AuthenticatedCompanyBuchhaltungIndexRoute: typeof AuthenticatedCompanyBuchhaltungIndexRoute
}

const AuthenticatedCompanyBuchhaltungRouteRouteChildren: AuthenticatedCompanyBuchhaltungRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungFocusedRouteRoute:
      AuthenticatedCompanyBuchhaltungFocusedRouteRouteWithChildren,
    AuthenticatedCompanyBuchhaltungSettingsRouteRoute:
      AuthenticatedCompanyBuchhaltungSettingsRouteRouteWithChildren,
    AuthenticatedCompanyBuchhaltungAusgangRouteRoute:
      AuthenticatedCompanyBuchhaltungAusgangRouteRouteWithChildren,
    AuthenticatedCompanyBuchhaltungEingangRouteRoute:
      AuthenticatedCompanyBuchhaltungEingangRouteRouteWithChildren,
    AuthenticatedCompanyBuchhaltungTransaktionenRouteRoute:
      AuthenticatedCompanyBuchhaltungTransaktionenRouteRouteWithChildren,
    AuthenticatedCompanyBuchhaltungLedgerRoute:
      AuthenticatedCompanyBuchhaltungLedgerRoute,
    AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute:
      AuthenticatedCompanyBuchhaltungMandantBearbeitenRoute,
    AuthenticatedCompanyBuchhaltungRechnungenRoute:
      AuthenticatedCompanyBuchhaltungRechnungenRoute,
    AuthenticatedCompanyBuchhaltungIndexRoute:
      AuthenticatedCompanyBuchhaltungIndexRoute,
  }

const AuthenticatedCompanyBuchhaltungRouteRouteWithChildren =
  AuthenticatedCompanyBuchhaltungRouteRoute._addFileChildren(
    AuthenticatedCompanyBuchhaltungRouteRouteChildren,
  )

interface AuthenticatedCompanyUnternehmenFocusedRouteRouteChildren {
  AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute: typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute
  AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute: typeof AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute
}

const AuthenticatedCompanyUnternehmenFocusedRouteRouteChildren: AuthenticatedCompanyUnternehmenFocusedRouteRouteChildren =
  {
    AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute:
      AuthenticatedCompanyUnternehmenFocusedRechnungIdSeitenBearbeitenRoute,
    AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute:
      AuthenticatedCompanyUnternehmenFocusedRechnungIdIndexRoute,
  }

const AuthenticatedCompanyUnternehmenFocusedRouteRouteWithChildren =
  AuthenticatedCompanyUnternehmenFocusedRouteRoute._addFileChildren(
    AuthenticatedCompanyUnternehmenFocusedRouteRouteChildren,
  )

interface AuthenticatedCompanyUnternehmenFullscreenRouteRouteChildren {
  AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute
  AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute
  AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute: typeof AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute
  AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute: typeof AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute
}

const AuthenticatedCompanyUnternehmenFullscreenRouteRouteChildren: AuthenticatedCompanyUnternehmenFullscreenRouteRouteChildren =
  {
    AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute:
      AuthenticatedCompanyUnternehmenFullscreenBezahlenErrorRoute,
    AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute:
      AuthenticatedCompanyUnternehmenFullscreenBezahlenFertigRoute,
    AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute:
      AuthenticatedCompanyUnternehmenFullscreenTransaktionenImportierenRoute,
    AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute:
      AuthenticatedCompanyUnternehmenFullscreenBezahlenIndexRoute,
  }

const AuthenticatedCompanyUnternehmenFullscreenRouteRouteWithChildren =
  AuthenticatedCompanyUnternehmenFullscreenRouteRoute._addFileChildren(
    AuthenticatedCompanyUnternehmenFullscreenRouteRouteChildren,
  )

interface AuthenticatedCompanyUnternehmenSettingsRouteRouteChildren {
  AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute
  AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute: typeof AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute
}

const AuthenticatedCompanyUnternehmenSettingsRouteRouteChildren: AuthenticatedCompanyUnternehmenSettingsRouteRouteChildren =
  {
    AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenBankRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenDebitorenRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenKostenstellenRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenKreditorenRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenWeiterleitungRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenWhatsappWeiterleitungRoute,
    AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute:
      AuthenticatedCompanyUnternehmenSettingsEinstellungenIndexRoute,
  }

const AuthenticatedCompanyUnternehmenSettingsRouteRouteWithChildren =
  AuthenticatedCompanyUnternehmenSettingsRouteRoute._addFileChildren(
    AuthenticatedCompanyUnternehmenSettingsRouteRouteChildren,
  )

interface AuthenticatedCompanyUnternehmenTransaktionenRouteRouteChildren {
  AuthenticatedCompanyUnternehmenTransaktionenTodosRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenTodosRoute
  AuthenticatedCompanyUnternehmenTransaktionenIndexRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenIndexRoute
}

const AuthenticatedCompanyUnternehmenTransaktionenRouteRouteChildren: AuthenticatedCompanyUnternehmenTransaktionenRouteRouteChildren =
  {
    AuthenticatedCompanyUnternehmenTransaktionenTodosRoute:
      AuthenticatedCompanyUnternehmenTransaktionenTodosRoute,
    AuthenticatedCompanyUnternehmenTransaktionenIndexRoute:
      AuthenticatedCompanyUnternehmenTransaktionenIndexRoute,
  }

const AuthenticatedCompanyUnternehmenTransaktionenRouteRouteWithChildren =
  AuthenticatedCompanyUnternehmenTransaktionenRouteRoute._addFileChildren(
    AuthenticatedCompanyUnternehmenTransaktionenRouteRouteChildren,
  )

interface AuthenticatedCompanyUnternehmenRouteRouteChildren {
  AuthenticatedCompanyUnternehmenFocusedRouteRoute: typeof AuthenticatedCompanyUnternehmenFocusedRouteRouteWithChildren
  AuthenticatedCompanyUnternehmenFullscreenRouteRoute: typeof AuthenticatedCompanyUnternehmenFullscreenRouteRouteWithChildren
  AuthenticatedCompanyUnternehmenSettingsRouteRoute: typeof AuthenticatedCompanyUnternehmenSettingsRouteRouteWithChildren
  AuthenticatedCompanyUnternehmenTransaktionenRouteRoute: typeof AuthenticatedCompanyUnternehmenTransaktionenRouteRouteWithChildren
  AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute: typeof AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute
  AuthenticatedCompanyUnternehmenBelegeRoute: typeof AuthenticatedCompanyUnternehmenBelegeRoute
  AuthenticatedCompanyUnternehmenUeberweisungenRoute: typeof AuthenticatedCompanyUnternehmenUeberweisungenRoute
  AuthenticatedCompanyUnternehmenIndexRoute: typeof AuthenticatedCompanyUnternehmenIndexRoute
  AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute: typeof AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute
  AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute: typeof AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute
}

const AuthenticatedCompanyUnternehmenRouteRouteChildren: AuthenticatedCompanyUnternehmenRouteRouteChildren =
  {
    AuthenticatedCompanyUnternehmenFocusedRouteRoute:
      AuthenticatedCompanyUnternehmenFocusedRouteRouteWithChildren,
    AuthenticatedCompanyUnternehmenFullscreenRouteRoute:
      AuthenticatedCompanyUnternehmenFullscreenRouteRouteWithChildren,
    AuthenticatedCompanyUnternehmenSettingsRouteRoute:
      AuthenticatedCompanyUnternehmenSettingsRouteRouteWithChildren,
    AuthenticatedCompanyUnternehmenTransaktionenRouteRoute:
      AuthenticatedCompanyUnternehmenTransaktionenRouteRouteWithChildren,
    AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute:
      AuthenticatedCompanyUnternehmenAusgangsrechnungenRoute,
    AuthenticatedCompanyUnternehmenBelegeRoute:
      AuthenticatedCompanyUnternehmenBelegeRoute,
    AuthenticatedCompanyUnternehmenUeberweisungenRoute:
      AuthenticatedCompanyUnternehmenUeberweisungenRoute,
    AuthenticatedCompanyUnternehmenIndexRoute:
      AuthenticatedCompanyUnternehmenIndexRoute,
    AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute:
      AuthenticatedCompanyUnternehmenReportingAccountsIndexRoute,
    AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute:
      AuthenticatedCompanyUnternehmenReportingDashboardIndexRoute,
  }

const AuthenticatedCompanyUnternehmenRouteRouteWithChildren =
  AuthenticatedCompanyUnternehmenRouteRoute._addFileChildren(
    AuthenticatedCompanyUnternehmenRouteRouteChildren,
  )

interface AuthenticatedCompanyRouteRouteChildren {
  AuthenticatedCompanyBuchhaltungRouteRoute: typeof AuthenticatedCompanyBuchhaltungRouteRouteWithChildren
  AuthenticatedCompanyUnternehmenRouteRoute: typeof AuthenticatedCompanyUnternehmenRouteRouteWithChildren
  AuthenticatedCompanyDoppelansichtRoute: typeof AuthenticatedCompanyDoppelansichtRoute
  AuthenticatedCompanyIndexRoute: typeof AuthenticatedCompanyIndexRoute
}

const AuthenticatedCompanyRouteRouteChildren: AuthenticatedCompanyRouteRouteChildren =
  {
    AuthenticatedCompanyBuchhaltungRouteRoute:
      AuthenticatedCompanyBuchhaltungRouteRouteWithChildren,
    AuthenticatedCompanyUnternehmenRouteRoute:
      AuthenticatedCompanyUnternehmenRouteRouteWithChildren,
    AuthenticatedCompanyDoppelansichtRoute:
      AuthenticatedCompanyDoppelansichtRoute,
    AuthenticatedCompanyIndexRoute: AuthenticatedCompanyIndexRoute,
  }

const AuthenticatedCompanyRouteRouteWithChildren =
  AuthenticatedCompanyRouteRoute._addFileChildren(
    AuthenticatedCompanyRouteRouteChildren,
  )

interface AuthenticatedKanzleiRouteRouteChildren {
  AuthenticatedKanzleiNutzerRoute: typeof AuthenticatedKanzleiNutzerRoute
}

const AuthenticatedKanzleiRouteRouteChildren: AuthenticatedKanzleiRouteRouteChildren =
  {
    AuthenticatedKanzleiNutzerRoute: AuthenticatedKanzleiNutzerRoute,
  }

const AuthenticatedKanzleiRouteRouteWithChildren =
  AuthenticatedKanzleiRouteRoute._addFileChildren(
    AuthenticatedKanzleiRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCompanyRouteRoute: typeof AuthenticatedCompanyRouteRouteWithChildren
  AuthenticatedKanzleiRouteRoute: typeof AuthenticatedKanzleiRouteRouteWithChildren
  Authenticated403Route: typeof Authenticated403Route
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAdminCompanySetupRoute: typeof AuthenticatedAdminCompanySetupRoute
  AuthenticatedAdminMandantErstellenRoute: typeof AuthenticatedAdminMandantErstellenRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCompanyRouteRoute: AuthenticatedCompanyRouteRouteWithChildren,
  AuthenticatedKanzleiRouteRoute: AuthenticatedKanzleiRouteRouteWithChildren,
  Authenticated403Route: Authenticated403Route,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAdminCompanySetupRoute: AuthenticatedAdminCompanySetupRoute,
  AuthenticatedAdminMandantErstellenRoute:
    AuthenticatedAdminMandantErstellenRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthErrorRoute: AuthErrorRoute,
  OtpCodeRoute: OtpCodeRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
